import { BlogRollProps } from '../../types/pages/blog/BlogTypes';
import React, { useState } from 'react';
import { CalendarIcon, PersonIcon } from '../../modules/Icons';
import Link from 'next/link';
import moment from 'moment';

const BlogRoll: React.FC<BlogRollProps> = (props) => {
  const { articles } = props;
  const [focusedArticle, setFocusedArticle] = useState(null);

  return (
    <div className="max-w-[1920px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-8 md:px-16 2xl:px-36 bg-gray-900">
      {articles.map((article) => (
        <Link
          key={article.id}
          href={`/blog/${article.slug}`}
          onMouseEnter={() => setFocusedArticle(article.id)}
          className={`${focusedArticle == article.id ? 'focused-article' : ''}`}
        >
          <article className="bg-gray-800 rounded-[5px] overflow-hidden">
            <div className="w-full h-[240px] overflow-hidden">
              <div
                className={`bg-image w-full h-[240px] bg-center bg-cover`}
                style={{ backgroundImage: `url(${article.header_photo.url})` }}
              ></div>
            </div>
            <div className="p-5">
              <div className="mb-2">
                {article.categories.map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => (window.location.href = `/blog?category=${cat.slug}`)}
                    className="bg-gray-900 text-gray-600 rounded-[20px] py-2 px-3 text-[12px] mr-3"
                  >
                    {cat.title}
                  </button>
                ))}
              </div>
              <h2 className="inter font-bold text-[18px] leading-[28px] py-3">{article.title}</h2>
              <p className="text-gray-600 text-[14px] leading-[24px]">{article.subtitle}</p>

              <div className="flex gap-8 text-gray-600 uppercase text-[12px] pt-4">
                <div className="">
                  <CalendarIcon className="inline mr-1" />{' '}
                  {moment(article.shown_publish_date || article.publish_date).format('MMMM D, YYYY')}
                </div>

                {article.author && (
                  <div className="">
                    <PersonIcon className="inline w-4 fill-gray-500 mr-1" />
                    {article.author.name}
                  </div>
                )}
              </div>
            </div>
          </article>
        </Link>
      ))}
    </div>
  );
};

export default BlogRoll;
